import '@/styles/style.scss';
import '@/pages/details/details.scss';

import '@/components/comment/comment.js';
import '@/components/dropdown/dropdown.js';
import '@/components/bullet-list/bullet-list.js';
import '@/components/template/template.js';
import '@/components/diagram/diagram.js';




